const CouponStatus = [
    "DRAFT",
    "PUBLISHED"
];

export default CouponStatus;